var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { mobileFirstBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
/**
 * Indent variations:
 *
 * You should use a padding / margin css notation without `px`.
 *
 * Static
 * $united: 4
 * $united: 4, 6 // 4 for horizontal and 6 for vertical (aka top-bottom, left-right of a css margin or padding)
 * $united: 4, 6, 8 // 4 for top, 6 for vertical and 8 for bottom (aka top, left-right, bottom of a css margin or padding);
 * $united: 4, 6, 8, 12 //  4 for top, 6 for right, 8 for bottom and 12 for left (aka top/right/bottom/left of a css margin or padding);
 *
 * Dynamic
 * $mobile: 4, $desktop: 16
 * $mobile: 4, 8, $desktop: 12, 16
 * $mobile: 4, 8, 12, $desktop: 8, 12, 16
 * $mobile: 4, 8, 12, 16, $desktop: 8, 12, 16, 20
 */
export var indents = [0, 4, 8, 12, 16, 20, 24, 32, 36, 40, 48, 64, 80];
/**
 * Проверяет принадлежит ли переданное число типу Indent
 */
export var isIndent = function (_number) {
    return !!indents.find(function (el) { return el === _number; });
};
var getMarginFromCompositeValue = function (indent) { return indent.map(function (item) { return "".concat(item, "px"); }).join(' '); };
export var getPaddingByIncomingIndent = function (_a) {
    var $united = _a.$united, $mobile = _a.$mobile, $desktop = _a.$desktop;
    if ($united) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding: ", ";\n        "], ["\n            padding: ", ";\n        "])), getMarginFromCompositeValue($united));
    }
    else if ($mobile && $desktop) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            padding: ", ";\n\n            @media (min-width: ", ") {\n                padding: ", ";\n            }\n        "], ["\n            padding: ", ";\n\n            @media (min-width: ", ") {\n                padding: ", ";\n            }\n        "])), getMarginFromCompositeValue($mobile), mobileFirstBreakpoints.mobile, getMarginFromCompositeValue($desktop));
    }
};
var IndentContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n\n    ", ";\n"], ["\n    display: block;\n\n    ", ";\n"])), getPaddingByIncomingIndent);
export default IndentContainer;
var templateObject_1, templateObject_2, templateObject_3;
